import { render } from "./log-peserta.vue?vue&type=template&id=e298ee4e&scoped=true"
import script from "./log-peserta.vue?vue&type=script&lang=js"
export * from "./log-peserta.vue?vue&type=script&lang=js"

import "./log-peserta.vue?vue&type=style&index=0&id=e298ee4e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e298ee4e"]])

export default __exports__